import { Minus } from "lucide-react";
import { type ReactNode, useState } from "react";

interface FaqEntryProps {
    children?: ReactNode,
    // Define the props for the ImageText component here
    question?: string;
    className?: string;
}

export default function FaqEntry(props: FaqEntryProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={"bg-gray-100 p-6 rounded-lg " + props.className}>
            <h2 className="flex justify-between text-lg cursor-pointer" onClick={()=>setIsOpen(!isOpen)}>
                {props.question} 
                <div className="flex relative">
                    <Minus className={"absolute transition-rotate duration-300 text-[#194172]"}/>
                    <Minus className={"transition-rotate duration-300 "+ (isOpen? "rotate-0": "rotate-90")}/>
                </div>
            </h2>
            <div className={"text-lg text-black overflow-hidden "+ (isOpen? "h-fit mt-10": "h-0 ")}>
                {props.children}
            </div>
        </div>
    );
}